import { API } from "../../../utils/api";

export const authentication = async (payload) => {
  const res = await API.post("login", payload);
  return res.data;
};

export const getForgotPassword = async (payload) => {
  const res = await API.post("password/email", payload);
  return res.data;
};

export const resetPassword = async (payload) => {
  const res = await API.post("authentication/resetPassword", payload, {
    headers: payload?.tenantId ? { "X-TENANT": payload.tenantId } : {},
  });
  return res.data;
};

export const loginWithOtp = async (payload, tenantId) => {
  const res = await API.post("loginWithOtp", payload, {
    headers: tenantId ? { "X-TENANT": tenantId } : {},
  });
  return res.data;
};

export const resendOtpApi = async (payload, tenantId) => {
  const res = await API.post("resend-otp", payload, {
    headers: tenantId ? { "X-TENANT": tenantId } : {},
  });
  return res.data;
};

